import React from 'react'
import './skills.css'
import {BsPatchCheckFill} from 'react-icons/bs'

function Skills() {
    return (
        <section id='skills'>
          <h5>What Skills I Have</h5>
          <h2>My Skills</h2>
  
          <div className="container skills_container">
            
            <div className="experience__language">
              <h3>Language</h3>
              <div className="skills__content">
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>C#<span className="percent">85%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{width:'85%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>PHP<span className="percent">85%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{width:'85%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
              </div>
            </div>
  
            <div className="skills__framework">
              <h3>Framework</h3>
              <div className="skills__content">
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>ASP.NET<span className="percent">80%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{width:'80%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>DevExpress<span className="percent">80%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{width:'80%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
              </div>
            </div>
  
            <div className="skills__javascript">
              <h3>JavaScript</h3>
              <div className="skills__content">
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>Node.js<span className="percent">50%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style={{width:'50%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>React.js<span className="percent">60%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{width:'60%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>jQuery<span className="percent">85%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{width:'85%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
              </div>
            </div>
  
            <div className="skills__sql">
              <h3>SQL</h3>
              <div className="skills__content">
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>MySQL<span className="percent">75%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{width:'75%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>MSSQL 2018<span className="percent">90%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100" style={{width:'90%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
              </div>
            </div>
  
            <div className="skills__design">
              <h3>Design</h3>
              <div className="skills__content">
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>HTML/CSS<span className="percent">90%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100" style={{width:'90%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
              </div>
            </div>
  
            <div className="skills__server">
              <h3>Server</h3>
              <div className="skills__content">
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>AWS<span className="percent">80%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{width:'80%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
              </div>
            </div>
  
            <div className="skills__versiontool">
              <h3>Version Control Tool</h3>
              <div className="skills__content">
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>GitHub<span className="percent">75%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{width:'75%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>SVN<span className="percent">80%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{width:'80%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>Microsoft TFS<span className="percent">75%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{width:'75%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
              </div>
            </div>
  
  
            <div className="skills__agile">
              <h3>Agile Tool</h3>
              <div className="skills__content">
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>Asana<span className="percent">70%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width:'70%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
                <article className="skills__details">
                  <BsPatchCheckFill className='skills__details-icon'></BsPatchCheckFill>
                  <div>
                    <h4>Jira<span className="percent">65%</span></h4>
                    <div className='progress-bar-border'>
                      <div className='progress-bar' role="progressbar" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100" style={{width:'65%'}}></div>
                    </div>
                    <small className='text-light'>Experienced</small>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </section>
      )
    }

export default Skills
